export default "__VITE_PUBLIC_ASSET__c958306f__"